<div
  ref="eWrapper"
  class="ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper {{ agIconCheckboxClass }}"
  role="presentation"
  (click)="toggleChecked()"
  style="margin-left: 1px">
  <input ref="eInput" class="ag-input-field-input ag-checkbox-input" type="checkbox" id="ag-163-input" tabindex="-1" />
</div>
